<template>
  <div>
    <!-- <el-row :gutter="20" style="margin-bottom: 1em;">
      <el-col :span="4" v-if="acquisitions.length > 0">
        <el-pagination
            style="text-align:left;"
            @size-change="handleSizeChange"
            layout="sizes"
            :page-size="pagination.perPage"
            :page-sizes="[10, 20, 50, 100]">
        </el-pagination>
      </el-col>
      <el-col :span="acquisitions.length > 0 ? 20 : 24" align="right">
        <el-tooltip
            class="item"
            effect="dark"
            content="Buscar por: Folio|Tipo|Usuario|Oficina(s)|Estatus"
            placement="top-end">
          <i class="fas fa-search"></i>
        </el-tooltip>
        <el-input
            style="width: 300px;"
            placeholder="Buscar"
            prefix-icon="el-icon-search"
            v-model="filters.searchKeyword"
            clearable
            @change="getAcquisitions(filters)">
        </el-input>
      </el-col>
    </el-row> -->
    <!-- <div v-show="acquisitions.length === 0">
      <el-alert
          title="Resultado"
          description="No se encontraron adquisiciones"
          type="info"
          :closable="false"
          show-icon>
      </el-alert>
      <br>
    </div> -->
    <!-- <el-row v-if="profile == 1 || profile == 4">
      <el-alert
          type="info"
          :closable="false"
          show-icon>
                    <span>
                        Los registros desbloqueados se muestran este <span
                        style="color: rgba(252, 31, 42, 0.13); font-weight: bold !important;">color</span>
                    </span>
      </el-alert>
    </el-row>
    <br> -->
    <h4>
      Mis solicitudes
    </h4>
      
      <el-row v-if="profile == 1 || profile == 4">
        <el-alert type="info" class="alert-primary" :closable="false" show-icon style="margin-bottom: 8px;">
          Los registros desbloqueados se muestran en este
          <span style="color: rgba(252, 31, 42, 0.7);">Color <i class="fas fa-lg fa-square"></i></span>
        </el-alert>
      </el-row>
      <el-alert type="info" show-icon class="alert-primary" :closable="true">
        Los registros mostrados en <span style="color: #bda0d9;">Color <i class="fas fa-lg fa-square"></i></span>
        fueron comentados por el CAD o algún miembro de su área, clic en <i class="fas fa-lg fa-comments"></i>
        para conocer el detalle.
      </el-alert>
    
    <!-- <el-row v-if="profile != 2 && profile != 3"> -->
      <!-- <el-col :span="8">
        <label class="el-form-item__label">
          Mis solicitudes
        </label>
        <br>
        <el-switch
            @change="getAcquisitions(filters); filters.pending = false"
            active-text="Atendidas"
            inactive-text="Enviadas al área"
            style="display: block"
            v-model="filters.seen"
            active-color="#13ce66">
        </el-switch>
      </el-col> -->
      <!-- <el-col :span="8">
        <label class="el-form-item__label">
          Pendientes
        </label>
        <br>
        <el-alert type="info"
                  show-icon
                  :closable="true">
          Los registros mostrados en este color <img src="/img/tip.png" width="50">
          fueron comentados por el CAD o algún miembro de su área, clic en
          <i class="fas fa-comments"></i> para conocer el detalle.
        </el-alert>
        <el-checkbox @change="getAcquisitions(filters); filters.authorizer = false"
                     v-model="filters.pending" style="padding: 10px">
          Ver Pendientes
        </el-checkbox>
      </el-col> -->
      <!-- <el-col :span="8">
        <label class="el-form-item__label">
          Preautorizadas
        </label>
        <br>
        <el-checkbox @change="getAcquisitions(filters); filters.pending = false"
                     v-model="filters.authorizer" style="padding: 10px">
          Ver Preautorizadas
        </el-checkbox>
      </el-col> -->
      <!-- <el-col :span="6" v-if="profile == 1 || profile == 4">
        <el-button
            size="medium"
            plain
            type="warning"
            @click.prevent="unlockRequest(1)"
            icon="fas fa-lock-open">
          Bloquear/Desbloquar Solicitud
        </el-button>
      </el-col> -->
    <!-- </el-row> -->

    <el-row :gutter="20" class="justify-container-right" style="margin-bottom: 12px;">
      <el-col :span="3">
        <el-button type="success" @click="getFileUrl()" size="medium" icon="fas fa-file-excel" style="width: 100%;">
          Descargar solicitudes
        </el-button>
      </el-col>
      <el-col :span="4" v-if="profile == 1 || profile == 4">
        <el-button type="warning"  @click.prevent="unlockRequest(1)" size="medium" icon="fas fa-lock-open" style="width: 100%;">
          Bloquear/Desbloquear solicitud
        </el-button>
      </el-col>
      </el-row>

    <div class="card-filters">
      <h6>Filtrar solicitudes</h6>
      <el-row :gutter="20" class="justify-container-center">
        <el-col :span="4">
          <el-input v-model="filters.folio" size="large" placeholder="Folio" />
        </el-col>
        <el-col :span="4">
          <el-select v-model="filters.acquisitionType" filterable placeholder="Tipo" style="width: 100%">
            <el-option v-for="(item, key) in catalogs.catAcquisitionType" :key="key" :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input v-model="filters.username" size="large" placeholder="Usuario" />
        </el-col>
        <!-- REGIONES -->
        <el-col v-if="userInfo && ![2, 3].includes(userInfo.cat_profile_id)" :span="4">
          <el-select v-if="userInfo && userInfo.regions.length > 0" v-model="filters.regions" clearable
            @change="filters.offices = []" filterable multiple placeholder="Regiones" style="width: 100%">
            <el-option v-for="(item, key) in userInfo.regions" :key="key" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-else v-model="filters.regions" clearable @change="filters.offices = []" filterable multiple
            placeholder="Regiones" style="width: 100%">
            <el-option v-for="(item, key) in catalogs.catRegion" :key="key" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <!-- REGIONES -->
        <!-- OFICINAS -->
        <el-col v-if="userInfo && ![2, 3].includes(userInfo.cat_profile_id)" :span="4">
          <el-select v-if="catalogs.catRegion" v-model="filters.offices" clearable filterable multiple
            placeholder="Oficinas" style="width: 100%">
            <el-option-group
              v-for="region in catalogs.catRegion.filter(item => ((userInfo.regionsIDs.length === 0 || userInfo.regionsIDs.includes(item.id)) && filters.regions.length === 0) || filters.regions.includes(item.id) )"
              :key="region.id" :label="region.name">
              <el-option v-for="office in region.offices" :key="office.id" :label="office.location"
                :value="office.id" />
            </el-option-group>
          </el-select>
        </el-col>
        <!-- <el-col v-if="userInfo && ![2, 3].includes(userInfo.cat_profile_id)" :span="4">
          <el-select v-if="catalogs.catRegion" v-model="filters.offices" clearable filterable multiple
            placeholder="Oficinas" style="width: 100%">
            <el-option-group
              v-for="region in catalogs.catRegion.filter(item => (filters.regions.length === 0 || filters.regions.includes(item.id)))"
              :key="region.id" :label="region.region">
              <el-option v-for="office in region.offices" :key="office.id" :label="office.location"
                :value="office.id" />
            </el-option-group>
          </el-select>
        </el-col> -->
        <!-- OFICINAS -->
        <el-col :span="4">
          <el-input v-model="filters.status" size="large" placeholder="Estatus" />
        </el-col>
      </el-row>
      <br>
      <el-row :gutter="20" class="justify-container-center">
        <el-col :span="4">
          <el-switch @change="filters.pending = false" active-text="Atendidas" inactive-text="Enviadas al área"
            style="display: block" size="large" v-model="filters.seen" active-color="#13ce66">
          </el-switch>
        </el-col>
        <el-col :span="4" class="justify-container-center">
          <el-checkbox @change="filters.authorizer = false" v-model="filters.pending">
            Ver Pendientes
          </el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox @change="filters.pending = false" v-model="filters.authorizer">
            Ver Preautorizadas
          </el-checkbox>
        </el-col>
      </el-row>
      <br>
      <el-row :gutter="20" class="justify-container-center">
        <el-col :span="2">
          <el-button type="primary" @click="getAcquisitions(filters)" size="medium" icon="el-icon-search"
            style="width: 100%;">Buscar</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="info" @click="clearFiltersAcquisitions()" size="medium" icon="el-icon-refresh"
            style="width: 100%;">Limpiar</el-button>
        </el-col>
      </el-row>
    </div>

    <el-row class="page-container">
      <el-col :span="12" style="text-align: left">
        <p style="font-size: 14px;">Total de solicitudes: {{ pagination.total }}</p>
      </el-col>
      <el-col :span="12" style="text-align: right">
        <el-pagination  @size-change="handleSizeChange" layout="sizes"
        :page-size="pagination.perPage" :page-sizes="[10, 20, 50, 100]">
      </el-pagination>
      </el-col>
    </el-row>

    <div v-show="acquisitions.length > 0">
      <el-table
          border
          :data="acquisitions"
          size="small"
          style="width: 100%; word-break: break-word !important;"
          :row-class-name="tableRowClassName">
        <el-table-column
            sortable
            align="center"
            label="# Folio"
            prop="folio"
            width="150">
        </el-table-column>
        <el-table-column
            label="Nombre del Servicio">
          <template slot-scope="props">
            <div style="text-align: left !important; word-break: break-word !important">
              {{ props.row.service_name ? props.row.service_name.name : props.row.type_service.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Tipo"
            prop="type.name">
        </el-table-column>
        <el-table-column
            label="Última modificación por"
            prop="last_log.user.username">
        </el-table-column>
        <el-table-column
            label="Oficina"
            prop="office.representation_name">
          <template slot-scope="props">
            <div style="text-align: left !important; word-break: break-word !important">
              {{ props.row.office.representation_name ? props.row.office.representation_name : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Estatus"
            prop="last_log.status.name">

          <template slot-scope="props">
            <div style="text-align: center !important; word-break: break-word !important">
              {{ filterStatusName(props.row) }}
            </div>
          </template>

        </el-table-column>
        <el-table-column width="200"
                         label="Aprobaciones por Área"
                         v-if="profile == 4 || profile == 1">
          <template slot-scope="props">
            <div v-if="props.row.send_areas && props.row.send_areas.length > 0">
              <li v-if="filterShowVobo(props.row.send_areas, 1)">
                Vo.Bo Seguridad: <span
                  style="font-weight: bold !important">{{ filterVoBo(props.row.vo_areas, 1) }}</span><br>
              </li>
              <li v-if="filterShowVobo(props.row.send_areas, 2)">
                Vo.Bo Infraestructura: <span
                  style="font-weight: bold !important">{{ filterVoBo(props.row.vo_areas, 2) }}</span> <br>
              </li>
              <li v-if="filterShowVobo(props.row.send_areas, 3)">
                Vo.Bo Servicios Informáticos: <span
                  style="font-weight: bold !important">{{ filterVoBo(props.row.vo_areas, 3) }}</span> <br>
              </li>
              <li v-if="filterShowVobo(props.row.send_areas, 4)">
                Vo.Bo D.G.: <span style="font-weight: bold !important">{{ filterVoBo(props.row.vo_areas, 4) }}</span>
                <br>
              </li>
            </div>
            <div v-if="props.row.send_areas && props.row.send_areas.length == 0">
              <li>
                Esta solicitud no ha sido enviada a nigún Área Técnica.
              </li>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Acciones"
            align="center"
            width="100">
          <template slot-scope="acquisition">
            <el-button-group width="350" size="small">
              <el-tooltip class="item" effect="dark" content="Ver registro"
                          placement="top">
                <el-button
                    size="small"
                    type="info"
                    icon="fas fa-eye"
                    @click="goToEdit(acquisition.row)">
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Ver mensajes"
                          placement="top">
                <el-button
                    size="small"
                    type="success"
                    icon="fas fa-comments"
                    @click="showCommentsDialog(acquisition.row.hash_id)">
                </el-button>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: .5em">
        <el-pagination
            @current-change="handleCurrentChange"
            layout="total, ->, prev, pager, next"
            :page-size="pagination.perPage"
            :current-page.sync="pagination.currentPage"
            :total="pagination.total">
        </el-pagination>
      </el-row>
    </div>
    <div v-if="acquisitions.length == 0">
      <el-alert type="info" center :closable="false">
        Sin solicitudes para mostrar, realice una búsqueda para actualizar este resultado.
      </el-alert>
    </div>
    <el-dialog
        :title="`Comentarios del la solicitud ${acquisitionComments.folio}`"
        :visible.sync="showComments"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="80%">

      <div v-if="acquisitionComments.comments.length == 0" style="margin-top: 1em">
        <el-alert
            title="No hay comentarios"
            type="info"
            :closable="false">
        </el-alert>
      </div>
      <div v-else>
        <el-collapse accordion>
          <el-collapse-item
              v-for="comment in acquisitionComments.comments"
              :key="comment.id"
              :name="comment.id">
            <template slot="title">
              {{ comment.user.full_name }} / {{ comment.user.profile.name }} /
              {{ comment.created_at | moment("D MMMM YYYY H:m:s") }} / {{
                comment.status.name
              }}
            </template>
            <el-input type="textarea"
                      v-model="comment.comments"
                      style="word-break: break-word"
                      :disabled="(comment.user.cat_profile_id != userInfo.cat_profile_id)"
                      :autosize="{ minRows: 5, maxRows: 10}"
                      resize="none">
            </el-input>
          </el-collapse-item>
        </el-collapse>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="showComments = false; acquisitionComments.comments = []">
                    Cerrar
                </el-button>
            </span>
    </el-dialog>

    <el-dialog title="Desbloqueo"
               :visible.sync="unlock"
               fullscreen>
      <el-form ref="filters" :model="filters" label-position="top" label-width="120px" @submit.native.prevent>
        <el-row>
          <el-col>
            <el-form-item prop="searchKeyword"
                          label="Búsqueda"
                          :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9\- _]+?$/,message: 'Formato inválido'}]">
              <el-input v-model="filters.searchKeyword"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <br>
      <el-row>
        <el-col :span="12">
          <el-button-group>
            <el-button type="primary" @click="unlockRequest(2)">
              Buscar
            </el-button>
            <el-button type="danger" @click="unlockRequest(4)">
              Desbloquear
            </el-button>
            <el-button type="success" @click="unlockRequest(3)">
              Bloquear
            </el-button>
            <el-button @click="toggleSelection()">Limpiar selección</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <br>
      <el-table
          @selection-change="handleSelectionChange"
          :data="cloneAcquisitions"
          ref="multipleTable"
          size="small"
          style="width: 100%; word-break: break-word !important;"
          :row-class-name="tableRowClassName">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            sortable
            align="center"
            label="# Folio"
            prop="folio"
            width="150">
        </el-table-column>
        <el-table-column
            label="Nombre del Servicio">
          <template slot-scope="props">
            <div style="text-align: left !important; word-break: break-word !important">
              {{ props.row.service_name ? props.row.service_name.name : props.row.type_service.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Tipo"
            prop="type.name">
        </el-table-column>
        <el-table-column
            label="Última modificación por"
            prop="last_log.user.username">
        </el-table-column>
        <el-table-column
            label="Oficina"
            prop="office.representation_name">
          <template slot-scope="props">
            <div style="text-align: left !important; word-break: break-word !important">
              {{ props.row.office.representation_name ? props.row.office.representation_name : '' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Estatus"
            prop="last_log.status.name">

          <template slot-scope="props">
            <div style="text-align: center !important; word-break: break-word !important">
              {{ filterStatusName(props.row) }}
            </div>
          </template>

        </el-table-column>
        <el-table-column
            label="Acciones"
            align="center"
            width="100">
          <template slot-scope="acquisition">
            <el-button-group width="350" size="small">
              <el-tooltip class="item" effect="dark" content="Ver registro"
                          placement="top">
                <el-button
                    size="small"
                    type="info"
                    icon="fas fa-eye"
                    @click="goToEdit(acquisition.row)">
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Ver mensajes"
                          placement="top">
                <el-button
                    size="small"
                    type="success"
                    icon="fas fa-comments"
                    @click="showCommentsDialog(acquisition.row.hash_id)">
                </el-button>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import {EventBus} from '@/components/views/acquisition/inbox/EventBus.js';
import {mapState, mapGetters, mapActions, mapMutations} from "vuex";


export default {
  props: {
    period: {
      type: Number,
      required: true
    }
  },
  components: {},
  data() {
    return {
      acquisitions: [],
      filters: {
        folio: '',
        acquisitionType: '',
        username: '',
        regions: [],
        offices: [],
        status: '',
        searchKeyword: '',
        perPage: 10,
        seen: false,
        pending: false
      },
      showComments: false,
      cloneAcquisitions: [],
      acquisitionComments: {comments: []},
      pagination: {
        total: 0,
        lastPage: 0,
        currentPage: 1,
        perPage: 20,
      },
      unlock: false,
      multipleSelection: []
    }
  },

  watch: {
    'period'() {
      this.filters.periodSelected = this.period;
      this.getAcquisitions(this.filters);
    },

  },

  created() {
    this.init();
  },

  mounted() {
    this.filters.periodSelected = this.period;
    this.getAcquisitions(this.filters);
  },

  computed: {
    ...mapGetters(["userInfo"]),
    ...mapGetters("form", {
      catalogs: "catalogs",
    }),
    profile() {
      return this.$store.state.user.profile;
    },
  },

  methods: {
    ...mapActions('form', {
      initService: "initService",
    }),
    showLoading(message) {
      this.$store.dispatch(
          'loading/spinner',
          {msg: message, status: true},
          {root: true}
      );
    },
    init() {
      this.initService()
    },
    hideLoading() {
      this.$store.dispatch('loading/spinner', {}, {root: true});
    },
    getAcquisitions(filters, page) {
      this.showLoading('Cargando Adquisiciones...');
      filters.searchKeyword = _.trim(filters.searchKeyword);

      axios.get(`/api/acquisitions/service`, {params: {page: page, filters}}).then(response => {

        if (response.data.acquisitions) {

          if (response.data.acquisitions.data && response.data.acquisitions.data.length > 0) {
            EventBus.$emit('acquisitions-founded', {flag: true, filters: filters});
          } else {
            EventBus.$emit('acquisitions-founded', {flag: false, filters: filters});
          }

          if (response.data.acquisitions.data) {
            this.acquisitions = response.data.acquisitions.data;
            this.cloneAcquisitions = response.data.acquisitions.data;
            this.pagination.total = response.data.acquisitions.total;
            this.pagination.lastPage = response.data.acquisitions.last_page;
            this.pagination.perPage = response.data.acquisitions.per_page;
            this.pagination.currentPage = response.data.acquisitions.current_page;
          } else {
            this.acquisitions = response.data.acquisitions;
            this.pagination.total = response.data.acquisitions.length;
            this.pagination.perPage = 1000;
            this.pagination.currentPage = 1;
          }

        } else {

          this.$notify({
            title: 'Advertencia',
            message: 'Hubo un error, inténtelo nuevamente.',
            type: 'warning'
          });
        }

        this.hideLoading();

      }).catch(error => {
        console.log('error index', error)
        this.hideLoading();

        this.$notify({
          title: 'Error',
          message: 'Hubo un error, inténtelo nuevamente.',
          type: 'warning'
        });
      });
      ;
    },
    clearFiltersAcquisitions() {
      this.filters.folio = ''
      this.filters.acquisitionType = ''
      this.filters.username = ''
      this.filters.regions = []
      this.filters.offices = []
      this.filters.status = ''
      this.filters.searchKeyword = ''
      this.filters.perPage = 10
      this.filters.seen = false
      this.filters.pending = false

      this.getAcquisitions(this.filters)
    },
    handleSizeChange(val) {
      this.pagination.perPage = val;
      this.filters.perPage = val;
      this.filters.periodSelected = this.period;
      this.getAcquisitions(this.filters, this.pagination.currentPage);
    },
    handleCurrentChange(page) {
      this.getAcquisitions(this.filters, page);
    },
    goToEdit(item) {
      //window.open(`/solicitudes/editar/${item.hash_id}`, '_blank')
      this.$router.push(`/solicitudes/editar/${item.hash_id}`);
    },

    tableRowClassName({row, rowIndex}) {
      if (row.last_log) {
        if ((row.last_log.status.id == 37
                || row.last_log.status.id == 38
                || row.last_log.status.id == 39
                || row.last_log.status.id == 40
                || row.last_log.status.id == 42
                || row.last_log.status.id == 44
                || row.last_log.status.id == 46
                || row.last_log.status.id == 48
                || row.last_log.status.id == 81
                || row.last_log.status.id == 82)
            && (this.userInfo?.cat_profile_id == 5
                || this.userInfo?.cat_profile_id == 6
                || this.userInfo?.cat_profile_id == 9
                || this.userInfo?.cat_profile_id == 10)
            && row.last_log.user_id != this.userInfo.id) {
          return 'not-my'
        }

        if (row.unlock == 0 || row.unlock == false) {
          return 'unlock-row'
        }
        if (row.last_log.status.id === 27
            || row.last_log.status.id == 78 || row.last_log.status.id == 80) {
          return 'success-row';
        } else if (row.last_log.status.id === 26
            || row.last_log.status.id == 69
            || row.last_log.status.id == 49
            || row.last_log.status.id == 62
            || row.last_log.status.id == 73
            || row.last_log.status.id == 77
            || row.last_log.status.id == 79) {
          return 'danger-row';
        } else {
          return '';
        }
      }
    },

    filterShowVobo(data, type) {
      let _show = false;
      if (type == 1 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 37);
        if (_filter && _filter.length > 0) {
          _show = true
        }
      }
      if (type == 2 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 38);
        if (_filter && _filter.length > 0) {
          _show = true
        }
      }
      if (type == 3 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 39);
        if (_filter && _filter.length > 0) {
          _show = true
        }
      }
      if (type == 4 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 40);
        if (_filter && _filter.length > 0) {
          _show = true
        }
      }
      return _show;
    },

    filterVoBo(data, type) {
      let _voBo = 'No';
      if (type == 1 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 41);
        if (_filter && _filter.length > 0) {
          _voBo = 'Sí'
        }
      }
      if (type == 2 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 43);
        if (_filter && _filter.length > 0) {
          _voBo = 'Sí'
        }
      }
      if (type == 3 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 45);
        if (_filter && _filter.length > 0) {
          _voBo = 'Sí'
        }
      }
      if (type == 4 && data.length > 0) {
        let _filter = data.filter(up => up.cat_acquisition_status_id == 47);
        if (_filter && _filter.length > 0) {
          _voBo = 'Sí'
        }
      }
      return _voBo;
    },

    showCommentsDialog(acquisitionId) {
      axios.post('/api/acquisitions/acquisition-comments', {acquisitionId: acquisitionId})
          .then(response => {
            let _comments = response.data.acquisition.comments;
            this.acquisitionComments.comments = _comments;
            this.acquisitionComments.folio = response.data.acquisition.folio;
          });

      this.showComments = true;
    },

    filterStatusName(data) {
      let _profile = this.userInfo && this.userInfo.cat_profile_id ? this.userInfo.cat_profile_id : null;

      if (_profile == 2 || _profile == 3 && (data.send_areas || data.vo_areas)
          && (data.last_log.cat_acquisition_status_id > 37 && data.last_log.cat_acquisition_status_id <= 47)) {
        return 'En revisión por DGTII'
      } else if (_profile == 2 || _profile == 3 && data.last_log.cat_acquisition_status_id >= 60
          && data.last_log.cat_acquisition_status_id <= 78 && data.last_log.cat_acquisition_status_id != 62) {
        return 'En Predictamen de DGTII'

      } else {
        return data.last_log.status.name;
      }
    },

    filterNameService(row) {

    },

    filterPending(pending) {
      if (this.acquisitions && this.acquisitions.length > 0 && pending) {
        this.acquisitions = this.cloneAcquisitions.filter(function (e) {
          return e.last_log.cat_acquisition_status_id == 37
        });
      } else {
        this.getAcquisitions(this.filters, this.pagination.currentPage)
      }
    },

    unlockRequest(type) {
      if (type == 1) {
        this.unlock = true;
        this.cloneAcquisitions = Object.assign([], this.acquisitions);

      }

      if (type == 2) {
        this.$refs['filters'].validate(valid => {
          if (valid) {
            this.getAcquisitions(this.filters, this.pagination.currentPage)
          } else {
            this.$notify({
              title: 'Atención',
              message: 'Complete los campos requeridos',
              type: 'warning'
            });
          }
        })
      }

      if (type == 3 || type == 4) {

        if (this.multipleSelection.length > 0) {
          let _params = {
            ids: this.multipleSelection.map(up => up.id),
            type: type == 4 ? false : true
          }
          axios.post('/api/acquisitions/unlock-request', _params).then(response => {
            if (response.data.success) {
              this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
              this.unlock = false;
              this.getAcquisitions(this.filters, this.pagination.currentPage)
            } else {
              this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
            }
          }).catch(e => {
            this.$store.dispatch('notifications/error', {msg: 'Error inesperado'}, {root: true});
          })
        } else {
          this.$notify({
            title: 'Atención',
            message: 'Seleccione al menos una solicitud para desbloquear.',
            type: 'warning'
          });
        }

      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    getFileUrl() {
        this.showLoading('Descargando documento...');

        let filters = this.filters;

        axios.get('/api/acquisitions/acquisitions-excel', {responseType: 'blob', params: {filters}})
            .then(response => {
                let now = new Date().toLocaleDateString();
                const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = linkUrl;

                link.setAttribute('download', 'adquisiciones' + ' - ' + now + '.xlsx');
                document.body.appendChild(link);
                link.click();
                this.hideLoading();
                this.$notify({
                    title: 'Éxito',
                    message: 'Fue generado el reporte en excel',
                    type: 'success'
                });
            })
            .catch(error => {
                this.hideLoading();
                this.$notify({
                    title: 'Error',
                    message: 'No fue posible realizar la descarga, inténtelo nuevamente.',
                    type: 'warning'
                });
            });
      },
  }
}
</script>

<style>
.el-table .danger-row {
  background: rgba(255, 22, 0, 0.15);
}

.el-table .success-row {
  background: rgba(17, 249, 0, 0.13);
}

.el-table .unlock-row {
  background: rgba(252, 31, 42, 0.13);
}

.el-table .not-my {
  background: #E8DBF0;
}

.card-filters {
  border: 1px solid #DDD;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 20px;
  transition: box-shadow 0.3s ease-in-out;
}

.justify-container-center {
  display: flex;
  justify-content: center;
}

.justify-container-left {
  display: flex;
  justify-content: left;
}

.justify-container-right {
  display: flex;
  justify-content: right;
}

.page-container {
  margin-top: 15px;
  margin-bottom: 5px;
}

.alert-primary {
  margin-bottom: 10px;
}
</style>